'use strict';
const angular = require('angular');

export class MainHeaderAuthComponent {
  headerLinks = [
    {
    title: 'Messages',
    href: '/account/messages',
    className: 'header__link--messages',
  }
];

  constructor(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, navService, $location, userService, $http, fetch) {
    'ngInject';

    this.isLoggedIn = FB.isLoggedInSync;
    
    this.$firebaseAuth = $firebaseAuth();
    this.$state = $state;
    this.$cookies = $cookies;
    this.isAdmin = FB.isAdminSync;
    this.navService = navService;
    this.userService = userService;
    this.$scope = $scope;
    this.$scope.getCurrentUser = FB.getCurrentUserSync;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.fetch = fetch;
    this.$http = $http;


    this.$scope.headerLinks = this.headerLinks;
    this.$scope.unreadMessageCount = 0;

     // Set up polling for new messages
    this.pollMessages();
    this.pollInterval = setInterval(() => this.pollMessages(), 600000); // Poll every minute
  }

  $onInit() {
    this.locationChangeListener = this.$rootScope.$on('$locationChangeSuccess', this.updateBreadcrumb);

    this.updateBreadcrumb();
  }

  $onDestroy() {
    if(!this.locationChangeListener) return;

    this.locationChangeListener();
  }

  pollMessages() {
    // this.$scope.unreadMessageCount = 10;
    this.fetch.getAllItems('api/messages/test/count')
      .then(response => {
        console.log('Unread message count:', response.data.unreadCount);
        this.$scope.unreadMessageCount = response.data.unreadCount;
        if (!this.$scope.$$phase) {
          // this.$scope.$apply();
        }
      })
      .catch(err => {
        console.error('Error fetching unread message count:', err);
      });
  }

  updateBreadcrumb = () => {
    if (this.$scope.headerLinks) {
        const [activeHeaderLink] = this.headerLinks.filter(headerLink => this.$location.path() === headerLink.href);
        if (!activeHeaderLink) return;

        this.$rootScope.page = activeHeaderLink;
    }
}

}

export default angular.module('appApp.mainheaderauth', [])
  .directive('mainheaderauth', function(FB) {
    return {
      template: require('./mainheaderauth.html'),
      restrict: 'EA',
      controller: MainHeaderAuthComponent,
      controllerAs: 'mainHeadAuthCtrl',
      link: function(scope, element, attrs) {
        // Initialize user data
        FB.getCurrentUser()
          .then(userData => {
            scope.currentUser = userData;
          })
          .catch(err => console.error('Error getting user data:', err));
  
        // Listen for user data updates
        scope.$on('userDataUpdated', function(event, userData) {
          console.log('listening for user data updates:', userData); // Debug line
          scope.currentUser = userData;
          if (!scope.$$phase) {
            scope.$apply();
          }
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/mainheaderauth/mainheaderauth.directive.js